var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8151 9.43299V8.24975C14.8151 7.93593 14.6954 7.63497 14.4824 7.41306C14.2694 7.19116 13.9805 7.0665 13.6793 7.0665H2.32134C2.02011 7.0665 1.73122 7.19116 1.51821 7.41306C1.30521 7.63497 1.18555 7.93593 1.18555 8.24975V15.3492C1.18555 15.663 1.30521 15.964 1.51821 16.1859C1.73122 16.4078 2.02011 16.5325 2.32134 16.5325H13.6793C13.9805 16.5325 14.2694 16.4078 14.4824 16.1859C14.6954 15.964 14.8151 15.663 14.8151 15.3492V14.166V9.43299ZM4.59293 7.0665V5.018C4.59293 4.07655 4.95192 3.17366 5.59093 2.50796C6.22994 1.84225 7.09662 1.46826 8.00031 1.46826C8.904 1.46826 9.77068 1.84225 10.4097 2.50796C11.0487 3.17366 11.4077 4.07655 11.4077 5.018V7.0665H4.59293Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordLock);
export default __webpack_public_path__ + "static/media/password-lock.1a63be59504dc0316326f004970de97d.svg";
export { ForwardRef as ReactComponent };